<template>
  <div class="container">
    <div class="bgcF">
      <div class="nav-tab">
        <img src="../../assets/images/arrow.png" alt="" />
        <div>您的当前位置是：组织机构</div>
      </div>
      <div class="content">
        <div class="left">
          <div class="nav-titie">
            组织机构
            <div class="list-box">
              <div v-for="(item, index) in list" :key="index" class="sidebar" :class="{ active: selectedItem === item }"
                @click="selectItem(item)">
                {{ item }}
              </div>
              <img src="../../assets/images/nav-img.png" alt="" />
            </div>
          </div>
        </div>
        <div class="right">
          <div v-show="selectedItem" class="box">
            <div v-show="selectedItem === '支队领导'" class="detachment-leader">
              <div class="dispF">
                <div style="margin: 10px 60px 16px 60px" v-for="(item, index) in teamList.slice(0, 2)" :key="index">
                  <img v-if="item.photo" :src="item.photo" alt="" />
                  <div class="name-detail">
                    {{ item.position }} {{ item.name }}
                  </div>
                </div>
              </div>
              <div class="dispF">
                <div style="margin: 10px 60px 16px 60px" v-for="(item, index) in teamList.slice(2, 4)" :key="index">
                  <img v-if="item.photo" :src="item.photo" alt="" />
                  <div class="name-detail">
                    {{ item.position }} {{ item.name }}
                  </div>
                </div>
              </div>
              <div class="dispF" style="background-color: #fff !important">
                <div style="margin: 10px 60px 16px 60px" v-for="(item, index) in teamList.slice(4, 6)" :key="index">
                  <img v-if="item.photo" :src="item.photo" alt="" />
                  <div class="name-detail">
                    {{ item.position }} {{ item.name }}
                  </div>
                </div>
              </div>
              <div class="dispF" style="background-color: #fff !important">
                <div style="margin: 10px 60px 16px 60px" v-for="(item, index) in teamList.slice(6, 8)" :key="index">
                  <img v-if="item.photo" :src="item.photo" alt="" />
                  <div class="name-detail">
                    {{ item.position }} {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
            <!-- <div v-show="selectedItem === '机关简介'" class="intro">
              <div
                style="
                  font-weight: bold;
                  font-size: 24px;
                  color: #333333;
                  text-align: center;
                  margin-bottom: 20px;
                "
              >
                机关简介
              </div>
              <span
                id="text"
                style="
                  width: 760px;
                  font-size: 16px;
                  color: #333333;
                  text-indent: 2em;
                  margin-left: 40px;
                "
                v-html="oragenFrom.organBlurb"
              >
              </span>
              <img
                src="../../assets/images/intro.png"
                alt=""
                style="width: 840px"
              />
            </div> -->
            <div v-show="selectedItem === '队伍概况'" class="location">
              <div style="
                  font-weight: bold;
                  font-size: 24px;
                  color: #333333;
                  text-align: center;
                  margin-bottom: 20px;
                ">
                队伍概况
              </div>
              <div style="
                  width: 760px;
                  font-size: 16px;
                  color: #333333;
                  margin: 0 auto;
                  text-indent: 2em;
                " v-html="oragenFrom.organBlurb"></div>
            </div>
            <div v-show="selectedItem === '地理位置'" class="location">
              <div style="
                  font-weight: bold;
                  font-size: 24px;
                  color: #333333;
                  text-align: center;
                ">
                地理位置
              </div>
              <!-- 地图 -->
              <div v-show="selectedItem === '地理位置'" id="map" style="width: 100%; height: 398px; margin-top: 20px"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-info">
        <div class="bottom-box">
          <div>
            <span class="hover-underline" @click="tps(0)">首页</span>
            <span> 丨 </span>
            <span class="hover-underline" @click="tps(1)">地理位置</span>
            <span> 丨 </span>
            <span class="hover-underline" @click="tps(2)">联系我们</span>
            <span> 丨 </span>
            <span class="hover-underline" @click="tps(3)">技术支持</span>
          </div>
          <div>主办单位：池州市消防救援支队</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
// window._AMapSecurityConfig = {
//     securityJsCode: 'ba80a7b6b468fb9befc8b9c4a85b4051'  //你的安全密钥
// }
import { listOrgan, listspecial, listTeam } from "@/api/index";
export default {
  data() {
    return {
      // , "机关简介"
      list: ["支队领导", "队伍概况", "地理位置"],
      selectedItem: "支队领导",
      leaderList: [],
      text: "",
      organization: "",
      map: null,
      team: "",
      serachFrom: {
        pageNum: 1,
        pageSize: 10,
      },
      oragenFrom: {},
      maker: null,
      teamList: [],
    };
  },
  mounted() {

    const params = new URLSearchParams(window.location.search);
    this.organization = params.get("organization");

  },
  created() {
    this.getlistOrgan();
    // this.getlistspecial();
    this.listTeam();
  },
  methods: {
    tps(type) {
      let url
      if (type == 1) {
        url = `/?organization=地理位置`;
      } else if (type == 2) {
        url = `/?call=1`;
      } else if (type == 3) {
        url = `http://www.ahqmkeji.com/aboutus`;
      } else {
        url = `/`;
      }
      window.open(url, "_blank");
    },
    listTeam() {
      listTeam({ ...this.serachFrom, shows: 1 }).then((res) => {
        this.teamList = res.data.data.list;
        console.log(this.teamList, "this.teamList");
      });
    },
    getlistOrgan() {
      listOrgan(this.serachFrom).then((res) => {
        this.oragenFrom = res.data.rows[0];
        console.log(this.oragenFrom);
        console.log(0);
        if (this.organization) {
          console.log(1);
          
        this.selectItem(this.organization)
      }
      });
      // this.initMap()
      
    },

    selectItem(item) {
      this.selectedItem = item;
      if (item == "地理位置") {
        this.initMap();
      }
      // if (item == "支队领导") {
      //   this.$forceUpdate()
      // }
    },
    initMap() {
      let load = AMapLoader.load({
        key: "fa4749c8f45ee918b1419fdcb507d4af", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          this.map = new AMap.Map("map", {
            //设置地图容器id
            viewMode: "3D", //是否为3D地图模式
            zoom: 15, //初始化地图级别
            center: [this.oragenFrom.lon, this.oragenFrom.lat], //初始化地图中心点位置
          });
          this.addMarker(this.oragenFrom.lon, this.oragenFrom.lat);

        })
        .catch((e) => {
          console.log(e);
        });
      console.log(load);
    },
    // 添加标记的函数
    addMarker(longitude, latitude) {
      const marker = new AMap.Marker({
        position: new AMap.LngLat(longitude, latitude), // 设置标记的位置
        map: this.map, // 将标记添加到地图上
        icon: require("@/assets/images/mapMarker.png"),
      });
    },
  },
};
</script>

<style scoped lang="scss">
#map {
  width: 100%;
  height: 398px;
}

.container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.bgcF {
  width: 1120px;
  background-color: #fff;
}

.dispF {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 16px;

  .lingdao {
    width: 64px;
    height: 35px;
    line-height: 35px;
    font-weight: bold;
    font-size: 16px;
    color: #333333;
  }
}

.nav-tab {
  width: 1120px;
  height: 48px;
  background: #f5f5f5;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;

  img {
    width: 23px;
    height: 20px;
    margin-left: 40px;
  }

  div {
    font-size: 16px;
    color: #2b56ac;
    margin-left: 16px;
  }
}

.content {
  width: 1120px;
  margin: 0;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  .left {
    .nav-titie {
      position: relative;
      width: 200px;
      height: 236px;
      background: #0e67ab;
      color: #fff;
      font-weight: bold;
      font-size: 20px;
      padding: 12px;
      box-sizing: border-box;

      .list-box {
        position: absolute;
        top: 53px;
        left: 12px;
        width: 195px;
        background-color: #fff;

        .sidebar {
          width: 188px;
          height: 56px;
          font-size: 14px;
          color: #333333;
          cursor: pointer;
          line-height: 56px;
          padding-left: 20px;
          box-sizing: border-box;
        }

        .sidebar.active {
          background-color: #d4ac62;
          color: #fff;
        }

        img {
          width: 168px;
          height: 100px;
          margin-top: 16px;
        }
      }
    }
  }

  .right {
    overflow: hidden;
    /* 隐藏超出窗口高度的内容 */
    width: 880px;
    // height: 633px;
    background: #ffffff;
    border: 1px solid #d6d8d7;
    margin-left: 40px;

    .box {
      width: 840px;
      // height: 633px;
      // overflow-y: auto;
      // padding: 40px 60px 0 60px;
    }

    /* 样式化滚动条 */
    .box::-webkit-scrollbar {
      width: 5px;
      /* 滚动条的宽度 */
    }

    /* 滚动条背景 */
    .box::-webkit-scrollbar-track {
      background-color: #f1f1f1;
      /* 滚动条轨道的颜色 */
    }

    /* 滚动条滑块 */
    .box::-webkit-scrollbar-thumb {
      background-color: #888;
      /* 滚动条滑块的颜色 */
      border-radius: 5px;
      /* 滚动条滑块的圆角 */
    }

    /* 鼠标悬停时滚动条滑块 */
    .box::-webkit-scrollbar-thumb:hover {
      background-color: #555;
      /* 鼠标悬停时滚动条滑块的颜色 */
    }

    /* 点击滚动条轨道时的空白区域 */
    .box::-webkit-scrollbar-track-piece {
      background-color: #ddd;
      /* 点击滚动条轨道时的空白区域颜色 */
    }

    /* 触摸设备上的滚动条 */
    .box::-webkit-scrollbar-thumb:vertical {
      background-color: #666;
      /* 竖直滚动条滑块的颜色 */
    }

    .box::-webkit-scrollbar-thumb:horizontal {
      background-color: #666;
      /* 水平滚动条滑块的颜色 */
    }

    /* 滚动条角落 */
    .box::-webkit-scrollbar-corner {
      background-color: #f1f1f1;
      /* 滚动条角落的颜色 */
    }

    .detachment-leader {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      padding: 40px 60px 0 60px;
      height: 833px;
      overflow-y: auto;
      img {
        width: 140px;
        height: 176px;
      }

      .name-detail {
        margin-top: 10px;
        width: 140px;
        text-align: center;
      }
    }

    // .detachment-leader > div:nth-child(2),
    // .detachment-leader > div:nth-child(5) {
    //   margin-left: 90px;
    //   margin-right: 90px;
    // }
    .intro {
      height: 633px;
      padding-top: 40px;
      background-color: #fff;

      #text {
        display: inline-block;
      }
    }

    .location {
      height: 633px;
      padding-top: 40px;
    }
  }
}

.bottom-info {
  width: 1120px;
  height: 100px;
  background: linear-gradient(180deg, #0E67AB 0%, #073456 100%);
  color: #fff;
  font-size: 14px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}

.hover-underline {
  cursor: pointer;
  /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline;
  /* 悬停时添加下划线 */
}
</style>
